export class ConveyanceResultDto {
    period: string;
    declarantToHomeOwner: number;
    declarantToBuilder: number;
    declarantToDeclarant: number;
    builderToHomeOwner: number;
    builderToDeclarant: number;
    builderToBuilder: number;
    homwOwnerToHomeOwner: number;
    homwOwnerToBuilder: number;
    homwOwnerToDeclarant: number;
}
